// ── GA4 event tracking ──
// Global so every block (incl. the Gravity Forms IIFE) can fire events.
window.dbTrack = function (name, params) {
  if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
};
// Delegated click tracking for links/buttons across the page.
document.addEventListener('click', function (e) {
  const el = e.target.closest && e.target.closest('a, button');
  if (!el) return;
  const href = el.getAttribute('href') || '';
  const text = (el.textContent || '').trim();
  if (el.classList.contains('db-ask__prompt')) dbTrack('ai_prompt_click', { prompt: text.slice(0, 100) });
  if (el.classList.contains('db-ask-ai-link')) dbTrack('ai_ask_click', { topic: (el.getAttribute('data-pai-label') || text).slice(0, 100) });
  if (href.indexOf('mailto:') === 0) {
    const addr = href.slice(7).split('?')[0];
    if (addr) dbTrack('email_click', { email: addr });
  } else if (/resume|\.pdf/i.test(href)) {
    dbTrack('resume_download', { link_url: href });
  }
  if (href === '#contact' || /work together/i.test(text)) dbTrack('cta_contact_click', { label: text.slice(0, 60) });
}, true);

document.addEventListener('DOMContentLoaded', function() {

// Stats card stagger
const statCards = document.querySelectorAll('.db-stats__card');
if (statCards.length) {
  const statsObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const cards = e.target.querySelectorAll ? statCards : [e.target];
        statCards.forEach((card, i) => {
          setTimeout(() => card.classList.add('db-stats__card--visible'), i * 120);
        });
        statsObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  if (statCards[0]) statsObs.observe(statCards[0].parentElement);
}

// Signal journey - traveling orb.
// vh, vw, and docH only change on resize / DOM growth, not on every scroll.
// Cache them and only update on resize to avoid forced reflows in the
// scroll handler.
const signalGlow = document.getElementById('signal-glow');
if (signalGlow) {
  let rafId;
  let vh = window.innerHeight;
  let vw = window.innerWidth;
  let docH = document.documentElement.scrollHeight;
  let xCenter = vw / 2;
  let xAmplitude = vw * 0.25;
  let yPos = (vh / 2) - 500;

  function recomputeSignalDims() {
    vh = window.innerHeight;
    vw = window.innerWidth;
    docH = document.documentElement.scrollHeight;
    xCenter = vw / 2;
    xAmplitude = vw * 0.25;
    yPos = (vh / 2) - 500;
  }

  function updateOrb() {
    const progress = window.scrollY / (docH - vh);
    const visible = progress > 0.08 && progress < 0.92;
    signalGlow.style.opacity = visible ? '1' : '0';

    // Sinusoidal horizontal path — weaves left and right
    const xOffset = Math.sin(progress * Math.PI * 6) * xAmplitude;
    signalGlow.style.left = (xCenter + xOffset - 500) + 'px';
    signalGlow.style.top  = yPos + 'px';
  }

  window.addEventListener('scroll', () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updateOrb);
  }, { passive: true });

  // Recompute cached layout values on resize (and when fonts/images load
  // and change the document height).
  window.addEventListener('resize', recomputeSignalDims, { passive: true });
  window.addEventListener('load', recomputeSignalDims);

  // Initial position
  updateOrb();
}

// Project Modal System
const projectData = {
  pressona: {
    title: 'Pressona',
    tagline: 'Next-Generation WordPress AI Assistant',
    year: '2026',
    badge: 'In Development',
    tags: ['Web Development', 'WordPress', 'AI Integration', 'Growth Systems', 'UI/UX Design'],
    tech: ['PHP', 'JavaScript', 'React', 'CSS', 'WordPress', 'Claude API', 'OpenAI API', 'REST API', 'SSE Streaming', 'MySQL'],
    prompt: 'Tell me about the Pressona AI assistant Dave built',
    paiRef: 'portfolio:5ce07d32-adde-4828-98b4-7935190716dc',
    paiLabel: 'Pressona AI - WordPress AI Assistant',
    desc: '<p>Most AI chat tools used on websites are disconnected from the business. They rely on third-party platforms, have limited awareness of site content, and fail to translate conversations into anything actionable.</p><p>Pressona is built to close that gap by turning conversations into structured business intelligence.</p><p>It transforms a website into a site-aware assistant that understands its own content, responds in real time, and captures user intent as usable data. Every interaction feeds into a system that surfaces demand signals, identifies content gaps, qualifies leads, and connects directly to business workflows.</p><p>This is not just a chat interface. It is an operational layer that converts conversations into insight, decisions, and action.</p>',
    built: ['Site-aware AI assistant trained on first-party website content', 'Modular prompt architecture adaptable by business type, role, goals, and conversion paths', 'Real-time content retrieval and streaming responses', 'Conversational UX designed for clarity, trust, and action', 'Prompt flows, interface states, and guidance patterns that move users from questions to next steps', 'Conversational lead capture embedded directly into the chat experience', 'Lead scoring and qualification signals based on intent, urgency, fit, budget, and conversation context', 'Leads inbox with conversation history, summaries, recommended next steps, and CRM-ready context', 'Insights dashboard surfacing demand signals, content gaps, trending topics, and visitor intent patterns', 'AI-assisted onboarding to configure assistant behavior, business knowledge, goals, and guardrails'],
    outcomes: ['Turns website conversations into actionable business intelligence', 'Captures and qualifies user intent directly within conversations', 'Converts passive site traffic into active engagement and lead flow', 'Surfaces content gaps, service demand, and recurring visitor questions', 'Reduces reliance on static forms and manual follow-up', 'Creates a structured data layer from user questions, lead signals, and conversation patterns', 'Connects front-end conversations to backend workflows, reporting, and CRM follow-up'],
    images: []
  },
  bellsight: {
    title: 'SEO, GEO & Accessibility Operations Platform',
    tagline: 'SEO, GEO & Accessibility Operations Platform',
    year: '2024 – Present',
    badge: 'Beta',
    tags: ['GEO & SEO', 'Reporting & Insights', 'Growth Systems', 'Web Development'],
    tech: ['Next.js', 'Supabase', 'Anthropic API', 'OpenAI API', 'Playwright', 'Inngest', 'PostHog'],
    prompt: 'Tell me about the Bellsight SEO and GEO platform Dave built',
    paiRef: 'portfolio:263677c6-bc04-4b1b-94ea-2389be61d76b',
    paiLabel: 'Bellsight: SEO, GEO &amp; Accessibility Operations Platform',
    desc: '<p>Most SEO platforms are built as research tools. They surface rankings, backlinks, audits, and technical issues, but stop short of helping teams decide what to fix first or how to implement it.</p><p>Bellsight connects SEO, GEO, accessibility, and site health into a prioritized operations system. It turns fragmented signals into clear recommendations, implementation-ready fixes, and a workflow for moving from insight to shipped improvement.</p>',
    built: ['Unified analysis across SEO, GEO, accessibility, and site health', 'AI-assisted audit layer combining rule-based checks with contextual interpretation', 'Cross-domain issue mapping across SEO, accessibility, and AI visibility overlap', 'Prioritized recommendation engine with rationale and confidence scoring', 'Implementation-ready fix drafts to reduce execution friction', 'Workflow system with inbox, task queue, and planning view', 'Conversational assistant operating as a senior strategist'],
    outcomes: ['Shifts teams from analysis to prioritized execution', 'Reduces time spent deciding what to fix and why', 'Surfaces high-impact opportunities across SEO, GEO, accessibility, and site health', 'Identifies visibility gaps in AI-driven search', 'Reduces unresolved technical and accessibility issues', 'Establishes a continuous optimization workflow from audit to implementation'],
    images: []
  },
  beacon: {
    title: 'AI-Powered Business Operations & Reporting Platform',
    tagline: 'AI-Powered Business Operations & Reporting Platform',
    year: '2025 – Present',
    badge: 'Production',
    tags: ['Systems Integration', 'Business Process Automation', 'Revenue & Capacity Analytics', 'Workflow Governance', 'UI/UX Design'],
    tech: ['Google Apps Script', 'JavaScript', 'Google Workspace APIs', 'WordPress REST API', 'WooCommerce', 'LLM APIs (OpenAI / Anthropic)', 'Web & video search APIs', 'HTML / CSS', 'REST integration', 'Multi-environment deployment'],
    prompt: 'Tell me about the Beacon business operations platform Dave built',
    paiRef: 'portfolio:2fe597e0-ef94-4fb6-ac39-781ee86f4170',
    paiLabel: 'Beacon: AI-Powered Business Operations & Reporting Platform',
    desc: '<p>Most web work stops at the front end. This project shows the rest: I build the business systems behind the website, the operations, data, automation, and reporting that run the organization, and connect them directly to the live, public-facing catalog so the two stay in sync.</p><p>Growing organizations often run core operations on a patchwork of spreadsheets, email threads, and manual updates, producing version conflicts, inconsistent data, delayed go-to-market, and heavy coordination overhead across teams, with no single source of truth and no link between internal planning and the live, revenue-generating catalog.</p><p>Beacon replaces that fragmented process with a single operations and reporting platform built on Google Workspace and a custom Google Apps Script application layer across 50+ custom modules. It manages the full business lifecycle of the organization\'s courses, including planning, pricing, approval, publishing, enrollment and revenue tracking, reporting, and annual renewal, and unifies five separate systems into one coordinated workflow.</p>',
    built: ['Centralized platform managing the full lifecycle of the organization\'s courses, from concept and pricing through publishing and delivery', 'Structured data model replacing inconsistent, siloed spreadsheets with a governed single source of truth', 'Custom application layer powering automation, validation, multi-stage workflows, and reporting', 'Role-based approval workflow with permission-gated stage transitions across operations, finance, registration, and marketing teams', 'Automated status tracking, stage-based notifications, and cross-department coordination', 'Bidirectional e-commerce integration: automated publishing to the public catalog plus live enrollment and capacity sync with deadline-aware alerting', 'Revenue and capacity analytics covering realized vs. potential vs. missed (unsold-inventory) revenue, utilization, and catalog concentration, by product line and channel', 'AI insights engine generating executive strategic analysis (risks, opportunities, and recommended actions) blending internal performance with live external market-trend signals', 'AI-assisted planning tool that turns concepts into structured course proposals informed by catalog gaps and competitive context', 'Automated annual catalog rollover that clones, resets, and carries selected courses into the new year hands-free', 'UI/UX design for high-density operational workflows, using visual hierarchy and cues that reduce cognitive load and surface priorities and next actions', 'Governance controls including taxonomy management, data normalization, duplicate detection, and user/permission administration'],
    outcomes: ['Eliminates fragmented workflows across spreadsheets, email, and manual updates', 'Establishes a single source of truth across operations, finance, registration, and marketing', 'Gives leadership real-time visibility into revenue, enrollment, and unsold capacity that was previously invisible across disconnected tools', 'Turns raw operational data into board-level strategic analysis without a dedicated analyst', 'Improves data quality and reduces costly operational errors through validation and governance', 'Cuts coordination overhead and shortens the path from planning to live, revenue-generating courses', 'Enables consistent, scalable management of 500+ courses annually with automated year-over-year renewal', 'Drives adoption by making a complex operation clear to every team that touches it'],
    images: []
  },
  alumni: {
    title: 'Alumni Network & Community Platform',
    tagline: 'Alumni Network & Community Platform',
    year: '2026 – Present',
    badge: 'Beta',
    tags: ['Web Development', 'WordPress', 'Systems Integration', 'Growth Systems', 'UI/UX Design'],
    tech: ['PHP', 'WordPress', 'BuddyBoss', 'MySQL', 'SSO', 'REST API', 'Claude API', 'JavaScript', 'AJAX'],
    prompt: 'Tell me about the Alumni Network platform Dave built',
    paiRef: 'portfolio:2e601121-2db7-485d-8c47-6e72515fb2a4',
    paiLabel: 'Alumni Network &amp; Community Platform',
    desc: '<p>Most alumni platforms are disconnected from the main website, rely on fragmented logins, and fail to create meaningful long-term engagement.</p><p>This platform unifies identity, community, portfolio sharing, member discovery, and program engagement into one connected system. It turns alumni from a static record set into an active network with shared data, real-time interaction, and ongoing pathways for participation.</p>',
    built: ['Community platform with profiles, groups, forums, activity feeds, and messaging', 'Custom plugin framework, BuddyTools, extending BuddyBoss with modular features', 'UI/UX design across the full community experience, improving navigation, interaction clarity, and usability', 'Refined BuddyBoss UX patterns to resolve limitations in default workflows', 'Portfolio system for image, video, and written work with feed integration', 'Interactive member map with location-based discovery, dynamic pins, and slide-out user panels', 'Public-facing directory supporting alumni discovery and hiring', 'Dashboard and navigation systems for a feature-rich platform', 'Contextual messaging, pre-action prompts, and guided flows to reduce friction', 'Announcement and notification system with targeting, scheduling, and engagement controls', 'Recommendation layer for groups, content, and future programming', 'Cross-site integration surfacing relevant programs within the community', 'Shared user-table architecture enabling SSO across two domains without multisite overhead', 'Google-based authentication and unified identity across domains', 'All non-user-generated content, including dashboard copy, UI helper text, prompts, form descriptions, onboarding language, and interaction guidance'],
    outcomes: ['Establishes a unified alumni identity system across platforms', 'Eliminates fragmented logins and duplicate account management', 'Creates an active engagement layer beyond program completion', 'Improves usability through clearer interaction design, navigation, and interface copy', 'Enables alumni discovery, hiring, and professional visibility', 'Reconnects alumni to ongoing programming and revenue pathways', 'Provides a scalable foundation for community growth and future expansion'],
    images: []
  },
  recommendation: {
    title: 'Discovery & Decision Intelligence Platform',
    tagline: 'Discovery & Decision Intelligence Platform',
    year: '2026',
    badge: 'Production',
    tags: ['Reporting & Insights', 'Growth Systems', 'GEO & SEO', 'Systems Integration'],
    tech: ['PHP', 'JavaScript', 'WordPress', 'WooCommerce', 'AJAX', 'REST API', 'MySQL', 'Custom Analytics'],
    prompt: 'Tell me about the discovery and decision intelligence platform Dave built',
    paiRef: 'portfolio:2d3c4564-1b37-43fe-9519-9440cb443ba6',
    paiLabel: 'Discovery &amp; Decision Intelligence Platform',
    desc: '<p>Content and commerce platforms often treat search and detail pages as endpoints, with generic recommendations that lack relevance and provide little visibility into customer intent.</p><p>This is a discovery and intelligence platform combining recommendation systems, internal search analytics, behavioral tracking, attribution, and conversion reporting. It transforms content discovery into a measurable system that connects user intent, engagement, and revenue.</p><p>By linking discovery behavior to downstream outcomes, the platform provides actionable insight that guides marketing, enrollment, content strategy, and programming decisions.</p>',
    built: ['Modular recommendation engine across multiple contexts including related content, instructor-based discovery, upcoming, new, nearly sold-out, and intent-driven recommendation modules', 'AI-assisted search with a three-tier query-rescue ladder (fuzzy match → taxonomy bypass → Claude-based correction) and a proper-noun guardrail so real names aren\'t miscorrected, across workshops, faculty, programs, and content', 'Deterministic ranking model using lift-scored (TF-IDF) weighting over AI-generated tags, not just co-occurrence, combined with taxonomy relationships, format alignment, availability filtering, and behavioral signals', 'Unified discovery layer connecting search, recommendations, and content exploration into a consistent user experience', 'Event pipeline tracking the full journey from render → impression → click → search → add-to-cart → purchase', 'Attribution framework linking engagement, discovery behavior, and revenue back to specific modules, searches, and placements', 'Enriched data model capturing category, format, level, pricing, schedule, instructor, acquisition source, search behavior, and conversion signals', 'Search intelligence and analytics dashboards surfacing audience demand, content gaps, engagement patterns, category performance, pricing sensitivity, and conversion pathways', 'Customer journey reconstruction framework combining ecommerce, search, email, form, and behavioral data into unified conversion-path analysis'],
    outcomes: ['Turns static pages and search interactions into active discovery systems that increase engagement and exploration', 'Converts internal search activity into a source of customer-intent and demand intelligence', 'Reveals pathways between workshops, certificates, and degree programs to surface cross-sell opportunities and unmet demand', 'Identifies content gaps, emerging interests, and search behavior patterns that inform content and program strategy', 'Provides attribution from discovery experiences to downstream conversion and purchase behavior', 'Gives program teams visibility into what users respond to across categories, formats, topics, and price points', 'Informs marketing, enrollment, content, and programming decisions through custom decision-support reporting', 'Captures 40+ behavioral, search, attribution, and conversion signals per interaction to support merchandising, demand analysis, and growth strategy', 'Reconstructs customer journeys across search, content, email, forms, and ecommerce systems to reveal acquisition pathways, conversion patterns, and growth opportunities'],
    images: []
  },
  transformation: {
    title: 'Digital Transformation & Growth Strategy',
    tagline: 'Digital Transformation & Growth Strategy',
    year: '2023 – Present',
    badge: 'Strategy',
    tags: ['Digital Transformation', 'Technology Strategy', 'Growth Systems', 'AI & GEO', 'Systems Integration'],
    tech: ['Digital Strategy', 'Roadmapping', 'Analytics', 'Business Intelligence', 'Systems Architecture', 'Customer Journey Analysis', 'SEO & GEO', 'Accessibility'],
    prompt: 'Tell me about the digital transformation and growth strategy work Dave does',
    paiRef: 'portfolio:14945e42-bf7b-488e-8bd4-afb495963a1b',
    paiLabel: 'Data-Driven Strategy, Roadmaps &amp; Advisory',
    desc: '<p>Digital transformation is rarely a technology problem. Most organizations already have the tools, platforms, and data they need. The challenge is identifying priorities, connecting systems, aligning stakeholders, and creating a roadmap that links technology investment to measurable business outcomes.</p><p>This work focused on developing strategic roadmaps that combined customer behavior, analytics, operational processes, platform architecture, search visibility, AI adoption, accessibility, and revenue opportunities into practical execution plans.</p><p>The result was a series of modernization initiatives designed to improve discoverability, customer acquisition, conversion, operational efficiency, reporting, and long-term organizational sustainability.</p>',
    built: ['Multi-year digital transformation roadmaps connecting technology investment to organizational goals', 'Website, LMS, CRM, community, and operational systems architecture planning', 'GEO and AI-discovery strategies focused on emerging search behavior and citation visibility', 'Accessibility modernization initiatives aligned with WCAG 2.2 AA standards and long-term compliance goals', 'Growth and acquisition frameworks linking workshops, certificates, and degree programs into connected customer journeys', 'Analytics and decision-support frameworks combining customer behavior, attribution, enrollment, marketing, and operational data', 'Data unification strategies designed to reduce silos and improve organizational reporting', 'Search visibility and content architecture plans focused on both traditional SEO and AI-driven discovery', 'Lead generation and nurture strategies informed by customer journey analysis and behavioral signals', 'Executive reporting, business cases, and investment recommendations supporting strategic decision-making'],
    outcomes: ['Identified hidden growth constraints through behavioral, operational, and financial analysis', 'Revealed customer acquisition, retention, and conversion opportunities across multiple product lines', 'Established strategic priorities for platform modernization and digital investment', 'Created roadmaps linking technology initiatives to revenue, efficiency, customer experience, and discoverability', 'Developed frameworks for measuring business impact beyond traditional website metrics', 'Helped leadership evaluate opportunities, risks, and investment priorities using data-driven recommendations', 'Positioned organizations to adapt to AI-driven discovery, changing search behavior, and evolving customer expectations'],
    images: []
  },
  lead: {
    title: 'Dynamic Lead Capture & Demand Intelligence System',
    tagline: 'Dynamic Lead Capture & Demand Intelligence System',
    year: '2025',
    badge: 'Production',
    tags: ['Growth Systems', 'SEO & GEO', 'Reporting & Insights'],
    tech: ['PHP', 'WordPress', 'WooCommerce', 'Gravity Forms', 'Mailchimp API', 'JavaScript', 'Geolocation', 'MySQL'],
    prompt: 'Tell me about the lead generation and demand intelligence system Dave built',
    paiRef: 'portfolio:2b703348-cc9c-488c-a4f5-467085a294d0',
    paiLabel: 'Dynamic Lead Capture &amp; Demand Intelligence System',
    desc: '<p>Inactive program pages often continue to attract high-intent search traffic, but without a live offering, that demand is typically lost.</p><p>This system turns those pages into conversion surfaces, capturing intent at the moment of interest and feeding it into both marketing and program planning workflows.</p>',
    built: ['Context-aware lead capture system deployed across non-running program pages', 'Conversion-focused UX and copy strategy aligned to search intent and user expectations', 'Dynamic form system tied to page-level context, program metadata, and taxonomy', 'Mailchimp integration routing leads into segmented audiences based on interest signals', 'Geolocation enrichment capturing regional demand patterns and audience distribution', 'Reporting layer translating submissions into program-level demand across topic, format, and geography'],
    outcomes: ['$45K+ in attributed sales since launch, tracked from captured demand through to purchase', 'Converts inactive pages into a continuous acquisition channel capturing high-intent demand', 'Generated over 1,000 qualified leads within the initial operating period', 'Captures demand across hundreds of program pages, validating long-tail search value', 'Reveals topic, format, and geographic demand patterns to inform programming decisions', 'Identifies repeat interest behavior and cross-program demand trends', 'Provides a structured dataset supporting marketing, scheduling, and forecasting decisions'],
    images: []
  },
  portfolio: {
    title: 'Custom WordPress Theme That Rewrites Itself',
    tagline: 'Custom WordPress Theme That Rewrites Itself',
    year: '2026',
    badge: 'Production',
    tags: ['Web Development', 'WordPress', 'Systems Integration', 'GEO & SEO'],
    tech: ['PHP', 'WordPress', 'Custom Post Types', 'JavaScript', 'esbuild', 'JSON-LD', 'GA4'],
    prompt: 'Tell me about the custom WordPress theme Dave built for this site',
    paiRef: 'portfolio:3d9d1278-1450-4670-88dd-5f62f27b341b',
    paiLabel: 'TheDaveBell.com',
    desc: '<p>This site is not a page builder or an off-the-shelf theme. It is a custom, hand-coded WordPress theme built to do one job well: present Dave to a specific role and answer a hiring team\'s questions in their own language.</p><p>A custom front end sits on top of a small content-operations layer, so one source of data drives the landing page, a live resume builder, a matching cover letter, and AI-readable structured data.</p>',
    built: ['Custom hand-coded theme (PHP, vanilla JavaScript, CSS) with no page builder or framework', 'Custom Role Variant post type powering /for/&lt;slug&gt;/ landing pages that override the hero, pills, summary, project order, and experience heading per target role', 'Custom cover-letter post type linked to variants, so each role gets a matching landing page, resume, and letter from one source of truth', 'Variant-aware live resume builder that generates a tailored PDF on demand from the same content the page uses', 'Custom JSON-LD structured data (Person, WebSite) plus per-page Open Graph and Twitter meta for SEO and AI discovery', 'Performance pipeline: esbuild-minified CSS and JS bundles, filemtime cache-busting, deferred assets, and a file_exists fallback to source', 'Custom interactive front end: project modal with swipeable artifact galleries, data carousels, animated card visuals, and a reconstructed customer-journey timeline', 'First-party GA4 event tracking for form submits, resume downloads, AI-assistant engagement, and project opens', 'Integrated AI assistant (Pressona) trained on Dave\'s experience, with context-aware ask-about-this prompts throughout'],
    outcomes: ['One content source drives the landing page, live resume builder, and cover letter, so tailoring for a new role takes minutes instead of a rebuild', 'Role-targeted landing pages let Dave speak directly to each opportunity without diluting the default positioning', 'Custom structured data and clean markup make the site readable and citable by search engines and AI assistants', 'Lean, dependency-free build keeps the site fast and fully under Dave\'s control, end to end', 'Demonstrates the exact stack and craft the work calls for: custom WordPress, PHP, JavaScript, systems thinking, and performance discipline'],
    images: []
  },
  'client-websites': {
    title: 'Client Websites, Designed, Built & Managed',
    tagline: 'Client Websites, Designed, Built & Managed',
    year: '2014 – Present',
    badge: '',
    tags: ['Web Management & Operations', 'WordPress Development', 'UX/UI', 'Ecommerce', 'MarTech & Integrations'],
    tech: ['WordPress', 'WooCommerce / Ecommerce', 'PHP / JavaScript', 'ACF / Gravity Forms', 'GA4 / GTM', 'Mailchimp / CRM Integrations', 'Salesforce API', 'Looker Studio', 'DNS & Hosting Support', 'Staging & QA', 'Technical SEO', 'Accessibility (WCAG)', 'Figma / Adobe Creative Suite'],
    prompt: 'Tell me about the client websites Dave has designed, built, and managed',
    paiRef: 'portfolio:d41198b8-240f-4d92-a34d-c807ba26430e',
    paiLabel: 'Client Websites, Designed, Built &amp; Managed',
    desc: '<p>Most organizations need more than a website. They need a web system that can support marketing, content, ecommerce, lead generation, reporting, and day-to-day operations without falling apart every time something changes.</p><p>A selection of websites, ecommerce platforms, and digital systems I have designed, built, managed, repaired, or supported across education, financial services, ecommerce, civic, cultural, nonprofit, hospitality, and commercial clients. My role has ranged from full strategy, UX, design, development, and launch to ongoing web management, troubleshooting, integrations, accessibility, reporting, and operational improvement.</p>',
    built: ['<strong>Maine Media Workshops + College</strong>: Current role, managing the full WordPress/WooCommerce web platform, including a $4M+ ecommerce layer, workshop catalog, lead generation systems, analytics, integrations, performance, SEO, accessibility, and connected community systems serving 10,000+ users. <a href="https://www.mainemedia.edu" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Appleyard Financial Services / Custom Wealth Solutions / Private Wealth Group</strong>: Managed web, CRM, advisor-support, and MarTech systems for a financial services group and dealer network, including lead-generation sites, investor funnels, workflow integrations, Xplan automation, and consulting support for licensed advisory firms. Legacy/acquired.', '<strong>Bixby Chocolate</strong>: Managed and supported the ecommerce web platform for a Maine specialty chocolate brand, including product and content updates, site maintenance, troubleshooting, marketing integrations, and operational web support. <a href="https://bixbychocolate.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Lindsey Doors</strong>: Managed ecommerce and web operations for a wholesale custom cabinet door business, supporting product structure, quote and order paths, updates, QA, and site reliability, and optimized a plugin-heavy custom-product configuration that had backend pages loading in 15–20 seconds down to about 2 seconds. <a href="https://lindseydoors.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>T. Hasegawa</strong>: Managed website operations for a global flavor and fragrance company, supporting content updates, maintenance, QA, platform reliability, and client-side web support. <a href="https://www.thasegawa.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Camden Snow Bowl</strong>: Consulted on design direction, integrations, content structure, and site management for a municipal recreation and ski-area website. <a href="https://camdensnowbowl.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Center for Maine Contemporary Art</strong>: Designed and built the website, extended and customized an event-management system to showcase exhibitions, built the donation flow, and developed the Salesforce API integration. Since redesigned.', '<strong>Knox Museum</strong>: Designed and built the website, including custom interactive historical timelines. Since redesigned.', '<strong>City of Rockland, rocklandmaine.gov</strong>: Designed and built the municipal website and administrative system, including committee management, content and event publishing, alerts, a custom tax-map tool, and a plain-language ordinance search for residents. Since redesigned.', '<strong>War Heroes on Water</strong>: Designed and built the site for this veterans\' nonprofit, delivered as a subcontractor to Alt9 Design. <a href="https://warheroesonwater.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Buckingham Investments</strong>: Built a commercial financial website on Salient with custom development, mortgage calculators, an embedded Looker Studio market dashboard, and listings integration. <a href="https://buckinghaminvestments.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Triden Group</strong>: Built and supported a clean, conversion-focused marketing site on Avada with custom development. <a href="https://tridengroup.com" target="_blank" rel="noopener">Visit live site &#8599;</a>', '<strong>Domenico\'s</strong>: Designed and built the website for this well-known restaurant. Live.', '<strong>Women Leaders Forum (WLF)</strong>: Managed the website for this Coachella Valley organization dedicated to advancing and empowering women, including updates, site improvements, SEO, and custom functionality. <a href="https://www.wlfdesert.org" target="_blank" rel="noopener">Visit live site &#8599;</a>'],
    outcomes: ['Managed live business websites, ecommerce systems, and client platforms where uptime, accessibility, clean forms, accurate tracking, and reliable workflows mattered.', 'Delivered complete websites end to end: strategy, UX, design, development, content structure, launch, and post-launch support.', 'Built and supported custom functionality where off-the-shelf tools fell short: event systems, calculators, embedded dashboards, civic tools, donation flows, ecommerce workflows, CRM integrations, and advisor-support systems.', 'Worked across the full spectrum: agency partner, subcontractor, independent consultant, in-house web manager, and ongoing platform owner.'],
    images: []
  },
  creative: {
    title: 'Digital Design, Brand & Creative Content',
    tagline: 'Digital Design, Brand & Creative Content',
    year: 'Ongoing',
    badge: '',
    tags: ['Web & UX Design', 'Prototyping', 'Brand & Marketing', 'Content & Video'],
    tech: ['Figma', 'Adobe XD', 'Adobe Illustrator', 'Adobe Photoshop', 'Adobe InDesign', 'Adobe Premiere Pro', 'Canva', 'UX/UI Design', 'Wireframing', 'Interactive Prototyping', 'Photography', 'Video Editing', 'Audio Editing', 'Copywriting'],
    prompt: 'Tell me about Dave\'s digital design, prototyping, and creative work',
    paiRef: 'portfolio:cac8505a-b0cc-4280-bef0-4689aff5f0e2',
    paiLabel: 'Digital Design, Brand &amp; Creative Content',
    desc: '<p>Website design, web and application prototyping, wireframes, brand identity, and marketing content produced across digital and print.</p><p>This work demonstrates my ability to take an idea from early structure and visual exploration through a complete interface, brand system, and supporting campaign materials.</p>',
    built: ['Designed websites, landing pages, application interfaces, and dashboards.', 'Wireframes, interactive prototypes, product mockups, and user journeys, turning ideas into testable structure before development.', 'Brand systems: logos, style guides, email designs, advertising, social content, and infographics.', 'Presentations and media: pitch decks, executive presentations, event materials, photography, video, audio, and print collateral.'],
    outcomes: ['Turned early concepts into clear, testable digital experiences before development, helping stakeholders understand structure, interactions, and user journeys.', 'Delivered cohesive visual systems that remained consistent across websites, applications, email, campaigns, presentations, video, social media, and print.'],
    images: []
  },
  'ssai-demo': {
    title: 'Earth Science Data Visualization',
    tagline: 'Earth Science Data Visualization',
    year: '2026',
    badge: 'Concept Demo',
    tags: ['Public Outreach', 'Accessibility', 'Data Storytelling', 'WordPress-ready'],
    tech: ['HTML', 'CSS', 'JavaScript', 'SVG', 'Canvas', 'WCAG Accessibility', 'Data Visualization'],
    prompt: 'Tell me about the Earth science concept demo Dave built',
    paiRef: 'portfolio:36c979e6-9701-4563-b535-5d34f428ff13',
    paiLabel: 'Earth Science Data Visualization',
    desc: '<p>Important scientific work often lives inside technical systems and specialist documentation. This concept explores how it can also become a clear, accessible, and engaging experience for broader audiences.</p><p>A concept explainer translating aquatic remote-sensing science, including how satellites detect water quality from space, into an accessible, interactive web experience for a general audience. It demonstrates how complex research and data can be transformed into a compelling digital story without sacrificing accuracy or context.</p><p><a href="https://thedavebell.com/demos/watching-water-from-space/" target="_blank" rel="noopener">View the live concept demo &#8599;</a></p><p><small>Independent concept demo using illustrative synthetic data. Not affiliated with or endorsed by NASA or any organization.</small></p>',
    built: ['Interactive scroll-based explainer with custom data visualizations', 'A step-by-step diagram of the underlying science', 'Responsive front-end design and accessible interaction patterns', 'Clear contextual explanations, with illustrative synthetic data and prominent disclaimers keeping the concept transparent'],
    outcomes: ['Transforms dense technical material into a concise, public-friendly experience', 'Demonstrates accessible and performant front-end development', 'Shows how scientific data can support outreach, education, recruitment, and organizational visibility'],
    images: []
  }
};

const projectKeys = Object.keys(projectData);
const projectModal = document.getElementById('project-modal');

if (projectModal) {
  let currentProjectIndex = 0;
  let currentImages = [];
  let currentImageIndex = 0;
  let currentArtifacts = [];
  let currentArtifactIndex = 0;
  let galleryMode = 'images';
  let tallImages = {};
  let lastTrigger = null;

  const gallery      = document.getElementById('project-modal-gallery');
  const counter      = document.getElementById('project-modal-counter');
  const galleryWrap  = projectModal.querySelector('.db-project-modal__gallery-wrap');
  const imgPrev      = projectModal.querySelector('.db-project-modal__img-prev');
  const imgNext      = projectModal.querySelector('.db-project-modal__img-next');
  const contentPanel = projectModal.querySelector('.db-project-modal__content');

  let galleryAnimating = false;
  const SLIDE_MS = 300;
  const SLIDE_EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';

  /* ── Toggle the gallery between the contained landscape stage and a
     scrollable frame, based on whether the loaded image is tall (full-page). ── */
  function applyImageFit(img) {
    const tall = img && img.naturalWidth > 0 && ( img.naturalHeight / img.naturalWidth > 1.4 );
    galleryWrap.classList.toggle('db-project-modal__gallery-wrap--tall', !!tall);
    if (tall) gallery.scrollTop = 0;
  }

  /* ── Show image by index. dir: 1 = next (right→left), -1 = prev (left→right), 0 = instant ── */
  function showImage(index, dir) {
    if (!currentImages.length) return;
    currentImageIndex = (index + currentImages.length) % currentImages.length;
    const src = currentImages[currentImageIndex];

    // Counter
    if (currentImages.length > 1) {
      counter.textContent = (currentImageIndex + 1) + ' / ' + currentImages.length;
      counter.removeAttribute('hidden');
      imgPrev.removeAttribute('hidden');
      imgNext.removeAttribute('hidden');
    } else {
      counter.setAttribute('hidden', '');
      imgPrev.setAttribute('hidden', '');
      imgNext.setAttribute('hidden', '');
    }

    // Tall (full-page) screenshots render in a scrollable frame, not the
    // sliding landscape stage — swap them in directly, no slide animation.
    if (tallImages[src]) {
      gallery.innerHTML = '';
      galleryWrap.classList.add('db-project-modal__gallery-wrap--tall');
      const img = document.createElement('img');
      img.src = src;
      img.alt = 'Screenshot ' + (currentImageIndex + 1);
      img.loading = 'eager'; img.decoding = 'async';
      img.onload = function () { applyImageFit(img); };
      gallery.appendChild(img);
      gallery.scrollTop = 0;
      return;
    }
    galleryWrap.classList.remove('db-project-modal__gallery-wrap--tall');

    const existing = gallery.querySelector('img');

    // No animation on first load or no direction
    if (!existing || !dir) {
      gallery.innerHTML = '';
      const img = document.createElement('img');
      img.src = src;
      img.alt = 'Screenshot ' + (currentImageIndex + 1);
      img.loading = 'eager'; img.decoding = 'async';
      img.onload = function () { applyImageFit(img); };
      gallery.appendChild(img);
      return;
    }

    if (galleryAnimating) return;
    galleryAnimating = true;

    // Pin existing in place
    existing.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;';

    // Build incoming off-screen
    const incoming = document.createElement('img');
    incoming.src = src;
    incoming.alt = 'Screenshot ' + (currentImageIndex + 1);
    incoming.loading = 'eager'; incoming.decoding = 'async';
    incoming.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;' +
      'transform:translateX(' + (dir > 0 ? '100%' : '-100%') + ');';
    gallery.appendChild(incoming);
    void incoming.offsetWidth; // force reflow so transition fires immediately

    existing.style.transition = 'transform ' + SLIDE_MS + 'ms ' + SLIDE_EASE;
    incoming.style.transition = 'transform ' + SLIDE_MS + 'ms ' + SLIDE_EASE;
    existing.style.transform  = 'translateX(' + (dir > 0 ? '-100%' : '100%') + ')';
    incoming.style.transform  = 'translateX(0)';

    setTimeout(() => {
      gallery.innerHTML = '';
      const final = document.createElement('img');
      final.src = src;
      final.alt = 'Screenshot ' + (currentImageIndex + 1);
      final.loading = 'eager'; final.decoding = 'async';
      gallery.appendChild(final);
      galleryAnimating = false;
    }, SLIDE_MS + 20);
  }

  /* ── Show a designed artifact slide (Digital Growth Strategy gallery).
     Cloning re-triggers the artifact's reveal animations. ── */
  function showArtifact(index) {
    if (!currentArtifacts.length) return;
    currentArtifactIndex = (index + currentArtifacts.length) % currentArtifacts.length;
    if (currentArtifacts.length > 1) {
      counter.textContent = (currentArtifactIndex + 1) + ' / ' + currentArtifacts.length;
      counter.removeAttribute('hidden');
      imgPrev.removeAttribute('hidden');
      imgNext.removeAttribute('hidden');
    } else {
      counter.setAttribute('hidden', '');
      imgPrev.setAttribute('hidden', '');
      imgNext.setAttribute('hidden', '');
    }
    gallery.innerHTML = '';
    gallery.appendChild(currentArtifacts[currentArtifactIndex].cloneNode(true));
    galleryWrap.scrollTop = 0;
  }

  /* ── Populate modal with project data ── */
  function populateModal(key) {
    const data = projectData[key];
    if (!data) return;

    // Grab images from tile data attribute (server-discovered) or fall back to JS data
    const tile = document.querySelector('[data-project="' + key + '"]');
    currentImages = data.images ? [...data.images] : [];
    if (tile && tile.dataset.images) {
      try { currentImages = JSON.parse(tile.dataset.images); } catch(e) {}
    }

    // Designed artifact slides (if this project has them) take precedence over images
    const artWrap = document.getElementById('db-artifacts-' + key);
    currentArtifacts = artWrap ? Array.prototype.slice.call(artWrap.querySelectorAll('.db-artifacts__slide')) : [];
    currentArtifactIndex = 0;

    // Preload all images immediately so they're cached before the user slides to them.
    // While preloading, record which are "tall" (full-page) so the gallery can render
    // them in a scrollable frame instead of the sliding landscape stage.
    tallImages = {};
    currentImages.forEach(src => {
      const p = new Image();
      p.onload = function () { tallImages[src] = ( p.naturalWidth > 0 && p.naturalHeight / p.naturalWidth > 1.4 ); };
      p.src = src;
    });

    // Header: project name + optional status badge
    const badgeHtml = data.badge
      ? ' <span class="db-project-modal__badge db-project-modal__badge--' +
        data.badge.toLowerCase().replace(/\s+/g, '-') + '">' + data.badge + '</span>'
      : '';
    document.getElementById('project-modal-title').innerHTML = data.title + badgeHtml;

    // Info panel — tagline bold at top
    const taglineEl = document.getElementById('project-modal-tagline');
    if (taglineEl) taglineEl.textContent = data.tagline;

    // Tags
    document.getElementById('project-modal-tags').innerHTML =
      data.tags.map(t => '<span class="db-pill">' + t + '</span>').join('');

    // Description
    document.getElementById('project-modal-desc').innerHTML = data.desc;

    // Results + Tech
    let resultsHtml = '';
    if (data.built && data.built.length) {
      resultsHtml += '<h4>What I delivered</h4><ul>' + data.built.map(r => '<li>' + r + '</li>').join('') + '</ul>';
    }
    if (data.outcomes && data.outcomes.length) {
      resultsHtml += '<h4>Key Outcomes</h4><ul>' + data.outcomes.map(r => '<li>' + r + '</li>').join('') + '</ul>';
    }
    if (data.signals && data.signals.length) {
      resultsHtml += '<h4>Selected Signals</h4><ul>' + data.signals.map(r => '<li>' + r + '</li>').join('') + '</ul>';
    }
    if (data.tech && data.tech.length) {
      resultsHtml += '<h4>Tools &amp; Methods</h4><div class="db-pill-row">' +
        data.tech.map(t => '<span class="db-pill">' + t + '</span>').join('') + '</div>';
    }
    if (data.prompt) {
      const paiRef   = data.paiRef   ? ' data-pai-ref="'   + data.paiRef   + '"' : '';
      const paiLabel = data.paiLabel ? ' data-pai-label="' + data.paiLabel + '"' : '';
      resultsHtml += '<a class="db-ask-ai-link" href="#ask-dave" data-pai-prompt="' + data.prompt + '" data-pai-mode="widget"' + paiRef + paiLabel + '>Ask AI Dave about this project &rarr;</a>';
    }
    document.getElementById('project-modal-results').innerHTML = resultsHtml;

    // Gallery: designed artifacts win, then screenshots, then placeholder
    galleryWrap.classList.remove('db-project-modal__gallery-wrap--tall');
    if (currentArtifacts.length) {
      galleryMode = 'artifacts';
      galleryWrap.classList.add('db-project-modal__gallery-wrap--artifacts');
      showArtifact(0);
    } else if (currentImages.length) {
      galleryMode = 'images';
      galleryWrap.classList.remove('db-project-modal__gallery-wrap--artifacts');
      showImage(0);
    } else {
      galleryMode = 'images';
      galleryWrap.classList.remove('db-project-modal__gallery-wrap--artifacts');
      gallery.innerHTML = '<div class="db-project-modal__empty-gallery"><span>Screenshots coming soon</span></div>';
      counter.setAttribute('hidden', '');
      imgPrev.setAttribute('hidden', '');
      imgNext.setAttribute('hidden', '');
    }

    if (contentPanel) contentPanel.scrollTop = 0;
  }

  /* ── Open / close / switch project ── */
  function openProject(key) {
    dbTrack('project_open', { project: key, project_name: (projectData[key] && projectData[key].title) || key });
    currentProjectIndex = projectKeys.indexOf(key);
    populateModal(key);
    projectModal.classList.add('db-project-modal--open');
    projectModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => projectModal.querySelector('.db-project-modal__close').focus(), 100);
  }

  function closeProject() {
    projectModal.classList.remove('db-project-modal--open');
    projectModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  function switchProject(newIndex) {
    currentProjectIndex = newIndex;
    populateModal(projectKeys[currentProjectIndex]);
  }

  /* ── Tile clicks ── */
  document.querySelectorAll('.db-projects__tile').forEach(tile => {
    tile.addEventListener('click', () => {
      lastTrigger = tile;
      openProject(tile.dataset.project);
    });
  });

  /* ── Close ── */
  projectModal.querySelector('.db-project-modal__close').addEventListener('click', closeProject);
  projectModal.addEventListener('click', (e) => { if (e.target === projectModal) closeProject(); });

  /* ── Project prev/next (header nav) ── */
  projectModal.querySelector('.db-project-modal__prev').addEventListener('click', () => {
    switchProject((currentProjectIndex - 1 + projectKeys.length) % projectKeys.length);
  });
  projectModal.querySelector('.db-project-modal__next').addEventListener('click', () => {
    switchProject((currentProjectIndex + 1) % projectKeys.length);
  });

  /* ── Lightbox: full gallery overlay with slide transition ── */
  function openLightbox(startIndex) {
    if (!currentImages.length) return;
    let lbIndex = (startIndex + currentImages.length) % currentImages.length;
    const multi = currentImages.length > 1;
    let lbAnimating = false;

    const lb = document.createElement('div');
    lb.className = 'db-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button class="db-lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="db-lightbox__prev" type="button" aria-label="Previous image"' + (multi ? '' : ' hidden') + '>&#8249;</button>' +
      '<div class="db-lightbox__stage"></div>' +
      '<button class="db-lightbox__next" type="button" aria-label="Next image"' + (multi ? '' : ' hidden') + '>&#8250;</button>' +
      '<div class="db-lightbox__counter"' + (multi ? '' : ' hidden') + '></div>';
    document.body.appendChild(lb);

    const lbStage = lb.querySelector('.db-lightbox__stage');
    const lbCount  = lb.querySelector('.db-lightbox__counter');

    function lbClose() {
      lb.remove();
      document.removeEventListener('keydown', lbKey);
    }

    function lbShow(idx, dir) {
      lbIndex = (idx + currentImages.length) % currentImages.length;
      const src = currentImages[lbIndex];
      if (multi) lbCount.textContent = (lbIndex + 1) + ' / ' + currentImages.length;

      const existing = lbStage.querySelector('img');

      // No animation on first load or no direction given
      if (!existing || !dir) {
        lbStage.innerHTML = '';
        const img = document.createElement('img');
        img.className = 'db-lightbox__img';
        img.src = src;
        img.alt = 'Screenshot ' + (lbIndex + 1);
        lbStage.appendChild(img);
        return;
      }

      if (lbAnimating) return;
      lbAnimating = true;

      existing.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;border-radius:var(--r-md);';
      const incoming = document.createElement('img');
      incoming.className = 'db-lightbox__img';
      incoming.src = src;
      incoming.alt = 'Screenshot ' + (lbIndex + 1);
      incoming.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;border-radius:var(--r-md);' +
        'transform:translateX(' + (dir > 0 ? '100%' : '-100%') + ');';
      lbStage.appendChild(incoming);
      void incoming.offsetWidth; // force reflow so transition fires immediately

      existing.style.transition = 'transform ' + SLIDE_MS + 'ms ' + SLIDE_EASE;
      incoming.style.transition = 'transform ' + SLIDE_MS + 'ms ' + SLIDE_EASE;
      existing.style.transform  = 'translateX(' + (dir > 0 ? '-100%' : '100%') + ')';
      incoming.style.transform  = 'translateX(0)';

      setTimeout(() => {
        lbStage.innerHTML = '';
        const final = document.createElement('img');
        final.className = 'db-lightbox__img';
        final.src = src;
        final.alt = 'Screenshot ' + (lbIndex + 1);
        lbStage.appendChild(final);
        lbAnimating = false;
      }, SLIDE_MS + 20);
    }

    // Initial load — instant, no slide
    lbShow(lbIndex);

    lb.querySelector('.db-lightbox__close').addEventListener('click', lbClose);
    lb.querySelector('.db-lightbox__prev').addEventListener('click', (e) => { e.stopPropagation(); lbShow(lbIndex - 1, -1); });
    lb.querySelector('.db-lightbox__next').addEventListener('click', (e) => { e.stopPropagation(); lbShow(lbIndex + 1, 1); });
    lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });

    // Touch swipe for lightbox
    let lbTouchX = 0;
    let lbTouchY = 0;
    lb.addEventListener('touchstart', (e) => {
      lbTouchX = e.touches[0].clientX;
      lbTouchY = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - lbTouchX;
      const dy = e.changedTouches[0].clientY - lbTouchY;
      if (!multi || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      dx < 0 ? lbShow(lbIndex + 1, 1) : lbShow(lbIndex - 1, -1);
    }, { passive: true });

    function lbKey(e) {
      if (e.key === 'Escape') { lbClose(); return; }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); lbShow(lbIndex - 1, -1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbIndex + 1, 1); }
    }
    document.addEventListener('keydown', lbKey);
  }

  /* ── Artifact lightbox: full-screen view of a designed strategy slide ── */
  function openArtifactLightbox(startIndex) {
    if (!currentArtifacts.length) return;
    let lbIndex = (startIndex + currentArtifacts.length) % currentArtifacts.length;
    const multi = currentArtifacts.length > 1;

    const lb = document.createElement('div');
    lb.className = 'db-lightbox db-lightbox--artifacts';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button class="db-lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="db-lightbox__prev" type="button" aria-label="Previous"' + (multi ? '' : ' hidden') + '>&#8249;</button>' +
      '<div class="db-lightbox__stage"></div>' +
      '<button class="db-lightbox__next" type="button" aria-label="Next"' + (multi ? '' : ' hidden') + '>&#8250;</button>' +
      '<div class="db-lightbox__counter"' + (multi ? '' : ' hidden') + '></div>';
    document.body.appendChild(lb);

    const lbStage = lb.querySelector('.db-lightbox__stage');
    const lbCount = lb.querySelector('.db-lightbox__counter');

    function lbShow(idx) {
      lbIndex = (idx + currentArtifacts.length) % currentArtifacts.length;
      if (multi) lbCount.textContent = (lbIndex + 1) + ' / ' + currentArtifacts.length;
      lbStage.innerHTML = '';
      lbStage.appendChild(currentArtifacts[lbIndex].cloneNode(true));
      lbStage.scrollTop = 0;
    }
    function lbClose() { lb.remove(); document.removeEventListener('keydown', lbKey); }
    function lbKey(e) {
      if (e.key === 'Escape') { lbClose(); return; }
      if (!multi) return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); lbShow(lbIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbIndex + 1); }
    }

    lb.querySelector('.db-lightbox__close').addEventListener('click', lbClose);
    lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });
    if (multi) {
      lb.querySelector('.db-lightbox__prev').addEventListener('click', () => lbShow(lbIndex - 1));
      lb.querySelector('.db-lightbox__next').addEventListener('click', () => lbShow(lbIndex + 1));
    }
    document.addEventListener('keydown', lbKey);
    lbShow(lbIndex);
  }

  if (galleryWrap) {
    galleryWrap.addEventListener('click', (e) => {
      // Artifacts: any click (except the nav arrows) opens the full-screen lightbox
      if (galleryMode === 'artifacts') {
        if (e.target === imgPrev || e.target === imgNext) return;
        openArtifactLightbox(currentArtifactIndex);
        return;
      }
      if (e.target.tagName === 'IMG') {
        e.stopPropagation();
        openLightbox(currentImageIndex);
        return;
      }
      // Click on wrap (not image, not buttons) = advance to next image
      if (e.target === imgPrev || e.target === imgNext) return;
      if (currentImages.length > 1) showImage(currentImageIndex + 1, 1);
    });

    // Touch swipe for modal gallery
    let galTouchX = 0;
    let galTouchY = 0;
    galleryWrap.addEventListener('touchstart', (e) => {
      galTouchX = e.touches[0].clientX;
      galTouchY = e.touches[0].clientY;
    }, { passive: true });
    galleryWrap.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - galTouchX;
      const dy = e.changedTouches[0].clientY - galTouchY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (galleryMode === 'artifacts') {
        if (currentArtifacts.length > 1) (dx < 0 ? showArtifact(currentArtifactIndex + 1) : showArtifact(currentArtifactIndex - 1));
        return;
      }
      if (currentImages.length < 2) return;
      dx < 0 ? showImage(currentImageIndex + 1, 1) : showImage(currentImageIndex - 1, -1);
    }, { passive: true });
  }
  if (imgPrev) {
    imgPrev.addEventListener('click', (e) => {
      e.stopPropagation();
      if (galleryMode === 'artifacts') showArtifact(currentArtifactIndex - 1);
      else showImage(currentImageIndex - 1, -1);
    });
  }
  if (imgNext) {
    imgNext.addEventListener('click', (e) => {
      e.stopPropagation();
      if (galleryMode === 'artifacts') showArtifact(currentArtifactIndex + 1);
      else showImage(currentImageIndex + 1, 1);
    });
  }

  /* ── Keyboard: Escape + arrows ── */
  document.addEventListener('keydown', (e) => {
    if (!projectModal.classList.contains('db-project-modal--open')) return;
    if (e.key === 'Escape') { closeProject(); return; }
    // Arrow keys: navigate artifacts/images if multiple exist, else navigate projects
    if (e.key === 'ArrowLeft') {
      if (galleryMode === 'artifacts' && currentArtifacts.length > 1) showArtifact(currentArtifactIndex - 1);
      else if (currentImages.length > 1) showImage(currentImageIndex - 1, -1);
      else switchProject((currentProjectIndex - 1 + projectKeys.length) % projectKeys.length);
    }
    if (e.key === 'ArrowRight') {
      if (galleryMode === 'artifacts' && currentArtifacts.length > 1) showArtifact(currentArtifactIndex + 1);
      else if (currentImages.length > 1) showImage(currentImageIndex + 1, 1);
      else switchProject((currentProjectIndex + 1) % projectKeys.length);
    }
  });

  /* ── Hash deep-link: #project-beacon, #project-alumni, etc. ── */
  function checkProjectHash() {
    const hash = window.location.hash;
    if (!hash.startsWith('#project-')) return;
    const key = hash.slice('#project-'.length);
    if (projectData[key]) openProject(key);
  }
  checkProjectHash();
  window.addEventListener('hashchange', checkProjectHash);

  /* ── Intercept all #project-* link clicks anywhere on the page ──
     hashchange won't fire if the hash is already set to the same value,
     so we catch clicks directly and call openProject() instead.        */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || !href.includes('#project-')) return;
    const key = href.split('#project-')[1];
    if (!key || !projectData[key]) return;
    e.preventDefault();
    openProject(key);
  });
}

// Single-image lightbox (used by collage and any standalone image)
function openSingleLightbox(src, alt) {
  const lb = document.createElement('div');
  lb.className = 'db-lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.innerHTML =
    '<button class="db-lightbox__close" type="button" aria-label="Close">&times;</button>' +
    '<div class="db-lightbox__stage"></div>';
  document.body.appendChild(lb);

  const stage = lb.querySelector('.db-lightbox__stage');
  const img = document.createElement('img');
  img.className = 'db-lightbox__img';
  img.src = src;
  img.alt = alt || '';
  stage.appendChild(img);

  function lbClose() {
    lb.remove();
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
  }

  function onKey(e) { if (e.key === 'Escape') lbClose(); }

  lb.querySelector('.db-lightbox__close').addEventListener('click', lbClose);
  lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });
  document.addEventListener('keydown', onKey);
  document.body.style.overflow = 'hidden';
}

// Collage fade-in + parallax
const collageWrap = document.querySelector('.db-collage__wrap');
const collageImg = collageWrap?.querySelector('img');
if (collageWrap) {
  const collageObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        collageWrap.classList.add('db-collage--visible');
        collageObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  collageObs.observe(collageWrap);

  // Click collage to open full-size lightbox
  collageWrap.style.cursor = 'zoom-in';
  collageWrap.addEventListener('click', (e) => {
    // Let links/buttons in the overlay (e.g. the CTA) act normally
    if (e.target.closest('a, button')) return;
    const src = collageImg ? collageImg.src : '';
    if (src) openSingleLightbox(src, collageImg.alt);
  });

  // Parallax — image moves slower than scroll
  if (collageImg) {
    window.addEventListener('scroll', () => {
      const rect = collageWrap.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.top < vh && rect.bottom > 0) {
        const progress = (vh - rect.top) / (vh + rect.height);
        const offset = (progress - 0.5) * -40;
        collageImg.style.transform = `translateY(${offset}px) scale(1.05)`;
      }
    }, { passive: true });
  }
}

// Digital Growth Strategy graphic — draw the climb once when it enters view
document.querySelectorAll('.db-tgfx').forEach(gfx => {
  const tgfxObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('db-tgfx--in');
        tgfxObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.35 });
  tgfxObs.observe(gfx);
});

// Collage pills stagger
const collagePills = document.querySelectorAll('.db-collage .db-pill');
if (collagePills.length) {
  const pillObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        collagePills.forEach((pill, i) => {
          setTimeout(() => pill.classList.add('db-pill--visible'), i * 80);
        });
        pillObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });
  pillObs.observe(collagePills[0]?.parentElement);
}

// Mobile hamburger menu
const hamburger    = document.getElementById('nav-hamburger');
const overlay      = document.getElementById('nav-overlay');
const overlayClose = document.getElementById('nav-overlay-close');

function openNav() {
  overlay.style.display = 'flex';
  // Double rAF forces a paint before adding --open so the opacity transition fires
  requestAnimationFrame(() => requestAnimationFrame(() => {
    overlay.classList.add('db-nav__mobile-overlay--open');
    if (overlayClose) overlayClose.focus();
  }));
  hamburger.classList.add('db-nav__hamburger--open');
  hamburger.setAttribute('aria-expanded', 'true');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeNav() {
  // Return focus to hamburger before setting aria-hidden to avoid focus-inside-hidden violation
  hamburger.focus();
  overlay.classList.remove('db-nav__mobile-overlay--open');
  hamburger.classList.remove('db-nav__hamburger--open');
  hamburger.setAttribute('aria-expanded', 'false');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  // Hide after fade-out completes. The setTimeout fallback handles cases where
  // transitionend never fires (e.g. prefers-reduced-motion disables the transition).
  let hidden = false;
  const hide = () => { if (hidden) return; hidden = true; overlay.style.display = 'none'; };
  overlay.addEventListener('transitionend', hide, { once: true });
  setTimeout(hide, 400);
}

if (hamburger && overlay) {
  // Hamburger toggle
  hamburger.addEventListener('click', () => {
    overlay.classList.contains('db-nav__mobile-overlay--open') ? closeNav() : openNav();
  });

  // Close button inside overlay
  if (overlayClose) overlayClose.addEventListener('click', closeNav);

  // Close on nav link click
  overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', closeNav));

  // Close on Escape key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('db-nav__mobile-overlay--open')) closeNav();
  });

  // Close when tapping the overlay background (not a child element)
  overlay.addEventListener('click', e => {
    if (e.target === overlay) closeNav();
  });
}

const obs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
}, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
document.querySelectorAll('[data-reveal]').forEach(el => obs.observe(el));

// Nav active
const sects = document.querySelectorAll('main section[id]');
const navAs = document.querySelectorAll('.db-nav__links a');
const navObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    navAs.forEach(a => {
      // Hrefs may be full URLs (variant-aware base), so compare only the hash
      const href = a.getAttribute('href') || '';
      const hashIndex = href.indexOf('#');
      const hash = hashIndex >= 0 ? href.slice(hashIndex) : '';
      a.classList.toggle('db-nav__link--active', hash === '#' + e.target.id);
    });
  });
}, { rootMargin: '-40% 0px -50% 0px' });
sects.forEach(s => navObs.observe(s));

// Counters
const cObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, val = +el.dataset.value, pre = el.dataset.prefix || '', suf = el.dataset.suffix || '', sep = el.dataset.sep === 'true';
    const dur = 1600, t0 = performance.now();
    (function tick(now) {
      const p = Math.min((now - t0) / dur, 1), ease = 1 - Math.pow(1 - p, 3), cur = Math.round(val * ease);
      el.textContent = pre + (sep ? cur.toLocaleString() : cur) + suf;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = pre + (sep ? val.toLocaleString() : val) + suf;
    })(t0);
    cObs.unobserve(el);
  });
}, { threshold: 0.5 });
document.querySelectorAll('.db-stats__count').forEach(c => cObs.observe(c));

// Experience - Nested Group Accordions
document.querySelectorAll('.db-exp__card').forEach(card => {
  // Buttons live inside h4.db-exp__group-heading-wrap. The button itself
  // carries the .db-exp__group-heading class for styling and aria-expanded.
  const headings = card.querySelectorAll('.db-exp__group-heading');
  headings.forEach((heading, i) => {
    // The UL sits as a sibling of the wrapping h4, not the button.
    const wrap = heading.closest('.db-exp__group-heading-wrap') || heading;
    const ul = wrap.nextElementSibling;
    if (!ul || ul.tagName !== 'UL') return;

    ul.classList.add('db-exp__group-ul');
    ul.style.maxHeight = '0px';

    const toggle = () => {
      const isOpen = heading.classList.contains('db-exp__group-heading--open');
      // Close all siblings first
      headings.forEach((h, j) => {
        if (j === i) return;
        const sibWrap = h.closest('.db-exp__group-heading-wrap') || h;
        const sibUl = sibWrap.nextElementSibling;
        if (sibUl && sibUl.tagName === 'UL') sibUl.style.maxHeight = '0px';
        h.classList.remove('db-exp__group-heading--open');
        h.setAttribute('aria-expanded', 'false');
      });
      heading.classList.toggle('db-exp__group-heading--open', !isOpen);
      heading.setAttribute('aria-expanded', String(!isOpen));
      ul.style.maxHeight = isOpen ? '0px' : ul.scrollHeight + 'px';

      // When opening, scroll the heading into view after transitions settle.
      // Siblings above may collapse (moving the heading up), so we wait for
      // the 280ms CSS transition before measuring the final position.
      if (!isOpen) {
        setTimeout(() => {
          if (!isTriggerVisible(heading)) {
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const top = heading.getBoundingClientRect().top + window.scrollY - 72 - 8;
            window.scrollTo({ top, behavior: reduced ? 'instant' : 'smooth' });
          }
        }, 290);
      }
    };

    // Button element handles Enter/Space natively, so just bind click.
    heading.addEventListener('click', toggle);
  });
});

// About - Stack Tabs
// About bio "Read more" toggle
const aboutMore = document.getElementById('about-more');
const aboutMoreToggle = document.getElementById('about-more-toggle');
if (aboutMore && aboutMoreToggle) {
  const aboutMoreLabel = aboutMoreToggle.querySelector('.db-about__more-label');
  let aboutMoreOpen = false;
  aboutMoreToggle.addEventListener('click', () => {
    aboutMoreOpen = !aboutMoreOpen;
    aboutMoreToggle.setAttribute('aria-expanded', aboutMoreOpen ? 'true' : 'false');
    aboutMore.classList.toggle('db-about__more--open', aboutMoreOpen);
    // scrollHeight ignores the collapsed max-height, so it gives full content height
    aboutMore.style.maxHeight = aboutMoreOpen ? aboutMore.scrollHeight + 'px' : '';
    if (aboutMoreLabel) aboutMoreLabel.textContent = aboutMoreOpen ? 'Show less' : 'Read more';
  });
  // Once open, release the fixed height so reflow/resize can't clip the content
  aboutMore.addEventListener('transitionend', e => {
    if (aboutMoreOpen && e.propertyName === 'max-height') aboutMore.style.maxHeight = 'none';
  });
}

const stackTabsEl = document.querySelector('.db-stack-tabs');
if (stackTabsEl) {
  // Inject sliding indicator
  const indicator = document.createElement('div');
  indicator.className = 'db-stack-tab-indicator';
  stackTabsEl.prepend(indicator);

  function slideIndicator(activeTab) {
    indicator.style.left  = activeTab.offsetLeft + 'px';
    indicator.style.width = activeTab.offsetWidth + 'px';
  }

  // Position on load (no transition yet)
  const firstActive = stackTabsEl.querySelector('.db-stack-tab--active');
  if (firstActive) {
    indicator.style.transition = 'none';
    slideIndicator(firstActive);
    requestAnimationFrame(() => { indicator.style.transition = ''; });
  }

  stackTabsEl.querySelectorAll('.db-stack-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      stackTabsEl.querySelectorAll('.db-stack-tab').forEach(t => {
        t.classList.toggle('db-stack-tab--active', t.dataset.tab === target);
        t.setAttribute('aria-selected', t.dataset.tab === target);
      });
      document.querySelectorAll('.db-stack-panel').forEach(p => {
        p.classList.toggle('db-stack-panel--hidden', p.dataset.panel !== target);
      });
      slideIndicator(tab);
    });
  });
}

// Why - Vertical Timeline
const whyTimeline = document.getElementById('why-timeline');
const whyItems = document.querySelectorAll('.db-why__item');
const whyFill = document.getElementById('why-timeline-fill');
const whyBanner = document.getElementById('why-banner');

if (whyTimeline && whyItems.length) {
  // Reveal items on scroll — once visible, stay visible (no reversal)
  const itemObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('db-why__item--visible');
        itemObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.3, rootMargin: '0px 0px -80px 0px' });
  whyItems.forEach(item => itemObs.observe(item));

  // Fill line — only grows, never shrinks, stops at the result card.
  // Layout values (offsetTop/offsetHeight) only change on resize or DOM
  // mutation, NOT on scroll — so cache them and skip the per-scroll reads
  // that were causing forced reflows.
  let maxFillPx = 0;
  let cachedMaxHeight = 0;
  let timelineRafId = 0;

  function recomputeTimelineMax() {
    const regularItems = whyTimeline.querySelectorAll('.db-why__item:not(.db-why__item--result)');
    const lastRegular = regularItems[regularItems.length - 1];
    cachedMaxHeight = lastRegular
      ? (lastRegular.offsetTop + lastRegular.offsetHeight + 40)
      : whyTimeline.offsetHeight;
  }

  function updateTimelineFill() {
    // Only one cheap layout read per scroll: the timeline's top edge.
    const rect = whyTimeline.getBoundingClientRect();
    const scrolled = window.innerHeight - rect.top;
    const rawHeight = Math.max(0, Math.min(scrolled, cachedMaxHeight));
    if (rawHeight > maxFillPx) {
      maxFillPx = rawHeight;
      if (whyFill) whyFill.style.height = maxFillPx + 'px';
    }
  }

  recomputeTimelineMax();
  updateTimelineFill();

  // Throttle scroll updates to one per animation frame.
  window.addEventListener('scroll', () => {
    if (timelineRafId) return;
    timelineRafId = requestAnimationFrame(() => {
      timelineRafId = 0;
      updateTimelineFill();
    });
  }, { passive: true });

  // Layout-affecting values change on resize and font load only.
  window.addEventListener('resize', recomputeTimelineMax, { passive: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(recomputeTimelineMax);
  }

  // Banner reveals — once visible, stays visible
  if (whyBanner) {
    const bannerObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          whyBanner.classList.add('db-why__banner--visible');
          bannerObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    bannerObs.observe(whyBanner);
  }
}

// AI Hub scroll trigger
const aiHub = document.getElementById('db-ai');
if (aiHub) {
  const hubObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) aiHub.classList.add('db-ai--animated');
      else aiHub.classList.remove('db-ai--animated');
    });
  }, { threshold: 0.15 });
  hubObs.observe(aiHub);
}


// AI Funnel convergence
const aiFunnel = document.getElementById('db-ai-funnel');
if (aiFunnel) {
  const funnelObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        aiFunnel.classList.add('db-ai-funnel--visible');
        funnelObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });
  funnelObs.observe(aiFunnel);
}

// AI Pillars scroll trigger
const aiPillars = document.querySelectorAll('.db-ai-pillar');
if (aiPillars.length) {
  const pillarObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('db-ai-pillar--visible');
        pillarObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  aiPillars.forEach(el => pillarObs.observe(el));
}

// Helper: is an element fully visible below the sticky nav?
function isTriggerVisible(el) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 72 && rect.bottom <= window.innerHeight;
}

// Experience accordion
document.querySelectorAll('.db-exp__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const card = trigger.closest('.db-exp__card');
    const body = card.querySelector('.db-exp__body');
    const isOpen = card.classList.contains('db-exp__card--open');

    // Close all others
    document.querySelectorAll('.db-exp__card--open').forEach(other => {
      if (other !== card) {
        const otherBody = other.querySelector('.db-exp__body');
        other.classList.remove('db-exp__card--open');
        otherBody.style.overflow = 'hidden';
        otherBody.style.maxHeight = otherBody.scrollHeight + 'px';
        otherBody.offsetHeight; // eslint-disable-line no-unused-expressions
        otherBody.style.maxHeight = '0';
      }
    });

    if (isOpen) {
      // Re-constrain from current real height before animating to 0,
      // so the closing transition has a valid start point.
      body.style.overflow = 'hidden';
      body.style.maxHeight = body.scrollHeight + 'px';
      // Force reflow so the browser registers the start value
      body.offsetHeight; // eslint-disable-line no-unused-expressions
      body.style.maxHeight = '0';
      card.classList.remove('db-exp__card--open');
    } else {
      card.classList.add('db-exp__card--open');
      body.style.overflow = 'hidden';
      body.style.maxHeight = body.scrollHeight + 'px';

      // After the open animation completes, free the height so Pressona
      // inline responses (or any injected content) can grow without clipping.
      setTimeout(() => {
        if (card.classList.contains('db-exp__card--open')) {
          body.style.maxHeight = 'none';
          body.style.overflow = 'visible';
        }
      }, 420);

      // Scroll trigger into view only if it isn't already visible —
      // avoids moving the page when the user manually scrolled to the trigger.
      setTimeout(() => {
        if (!isTriggerVisible(trigger)) {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const top = trigger.getBoundingClientRect().top + window.scrollY - 72 - 8;
          window.scrollTo({ top, behavior: reduced ? 'instant' : 'smooth' });
        }
      }, 420);
    }
  });
});

// Share dropdown
const shareBtn = document.getElementById('share-btn');
const shareDropdown = document.getElementById('db-share__dropdown');
const shareCopy = document.getElementById('share-copy');

if (shareBtn && shareDropdown) {
  shareBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    shareDropdown.classList.toggle('db-share__dropdown--open');
  });

  document.addEventListener('click', () => shareDropdown.classList.remove('db-share__dropdown--open'));
  shareDropdown.addEventListener('click', (e) => e.stopPropagation());

  if (shareCopy) {
    shareCopy.addEventListener('click', () => {
      navigator.clipboard.writeText(window.location.href).then(() => {
        shareCopy.querySelector('svg').style.display = 'none';
        const original = shareCopy.textContent;
        shareCopy.textContent = 'Copied!';
        setTimeout(() => {
          shareCopy.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg> Copy link';
          shareDropdown.classList.remove('db-share__dropdown--open');
        }, 1500);
      });
    });
  }
}

// Footer reveal
const footer = document.getElementById('db-footer');
if (footer) {
  const footObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) footer.classList.add('db-footer--visible'); });
  }, { threshold: 0.1 });
  footObs.observe(footer);
}

// Logo bar Flickity
const logoTrack = document.getElementById('db-logos__track');
if (logoTrack && typeof Flickity !== 'undefined') {
  new Flickity(logoTrack, {
    cellAlign: 'center',
    contain: true,
    freeScroll: true,
    friction: 0.4,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    draggable: true,
    cellSelector: '.db-logos__icon',
    percentPosition: false
  });
}

// Flickity carousel
const track = document.getElementById('db-carousel__track');
let flkty = null;
if (track && typeof Flickity !== 'undefined') {
  flkty = new Flickity(track, {
    cellAlign: 'center',
    contain: true,
    freeScroll: false,
    friction: 0.8,
    selectedAttraction: 0.2,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: false,
    draggable: true,
    cellSelector: '.db-carousel__card',
    percentPosition: false
  });
}

// Carousel card animations (triggered on Flickity select)
function animateDrawPaths(container) {
  container.querySelectorAll('.c-draw').forEach((path, i) => {
    if (path.getAttribute('stroke') && path.getAttribute('fill') === 'none') {
      const len = path.getTotalLength();
      path.style.strokeDasharray = len;
      path.style.strokeDashoffset = len;
      path.style.transition = `stroke-dashoffset 1.4s ${i * 150}ms cubic-bezier(.4,0,.2,1)`;
      requestAnimationFrame(() => path.style.strokeDashoffset = '0');
    } else {
      path.style.opacity = '0';
      path.style.transition = `opacity 800ms ${i * 100}ms ease`;
      requestAnimationFrame(() => path.style.opacity = '1');
    }
  });
}

function resetDrawPaths(container) {
  container.querySelectorAll('.c-draw').forEach(path => {
    path.style.transition = 'none';
    if (path.getAttribute('stroke') && path.getAttribute('fill') === 'none') {
      const len = path.getTotalLength();
      path.style.strokeDasharray = len;
      path.style.strokeDashoffset = len;
    } else {
      path.style.opacity = '0';
    }
  });
}

function animateBars(container) {
  container.querySelectorAll('.db-chart-bar__bar').forEach((bar, i) => {
    setTimeout(() => bar.classList.add('db-chart-bar__bar--animated'), i * 120);
  });
}

function resetBars(container) {
  container.querySelectorAll('.db-chart-bar__bar').forEach(bar => bar.classList.remove('db-chart-bar__bar--animated'));
}

function animateDonut(container) {
  container.querySelectorAll('circle[data-target]').forEach(c => {
    const target = +c.dataset.target;
    c.style.transition = 'stroke-dashoffset 1.4s cubic-bezier(.4,0,.2,1)';
    // data-target IS the final dashoffset (per HTML comments). Was previously inverted (314 - target),
    // which rendered the two arcs as the wrong percentages and left a gap between them.
    setTimeout(() => c.style.strokeDashoffset = target, 200);
  });
}

function resetDonut(container) {
  container.querySelectorAll('circle[data-target]').forEach(c => {
    c.style.transition = 'none';
    c.style.strokeDashoffset = 314;
  });
}

function animateApiFlow(container) {
  container.querySelectorAll('.db-api-flow__node, .db-api-flow__arrow').forEach((el, i) => {
    setTimeout(() => el.classList.add('db-api-flow__node--animated'), i * 150);
  });
}

function resetApiFlow(container) {
  container.querySelectorAll('.db-api-flow__node, .db-api-flow__arrow').forEach(el => el.classList.remove('db-api-flow__node--animated'));
}

function animateCard(card) {
  animateDrawPaths(card);
  animateBars(card);
  animateDonut(card);
  const ba = card.querySelector('.db-ba');
  if (ba) ba.classList.add('db-ba--animated');
  const cjourney = card.querySelector('.db-cjourney');
  if (cjourney) cjourney.classList.add('db-cjourney--animated');
  if (card.querySelector('.db-api-flow')) animateApiFlow(card);
  const funnel = card.querySelector('.db-funnel');
  if (funnel) funnel.classList.add('db-funnel--animated');
  const sysFlow = card.querySelector('.db-sys-flow');
  if (sysFlow) {
    sysFlow.classList.add('db-sys-flow--animated');
    // Synced arrow flashing — down+right together, up+left together
    if (!sysFlow.dataset.flashing) {
      sysFlow.dataset.flashing = 'true';
      const downArrow = sysFlow.querySelector('.db-sys-flow__arrow--down');
      const upArrow = sysFlow.querySelector('.db-sys-flow__arrow--up');
      const rightArrow = sysFlow.querySelector('.db-sys-flow__arrow--right');
      const leftArrow = sysFlow.querySelector('.db-sys-flow__arrow--left');
      const pairA = [downArrow, rightArrow].filter(Boolean);
      const pairB = [upArrow, leftArrow].filter(Boolean);

      function flashPair(pair) {
        pair.forEach(a => a.classList.add('db-sys-flow__arrow--flash'));
        setTimeout(() => pair.forEach(a => a.classList.remove('db-sys-flow__arrow--flash')), 400);
      }

      setInterval(() => {
        if (Math.random() > 0.5) flashPair(pairA);
        else flashPair(pairB);
      }, 700 + Math.random() * 600);

      // Independent random pattern for bottom arrows
      setInterval(() => {
        if (Math.random() > 0.5) { rightArrow.classList.add('db-sys-flow__arrow--flash'); setTimeout(() => rightArrow.classList.remove('db-sys-flow__arrow--flash'), 350); }
        else { leftArrow.classList.add('db-sys-flow__arrow--flash'); setTimeout(() => leftArrow.classList.remove('db-sys-flow__arrow--flash'), 350); }
      }, 500 + Math.random() * 700);
    }
  }
}

function resetCard(card) {
  resetDrawPaths(card);
  resetBars(card);
  resetDonut(card);
  const ba = card.querySelector('.db-ba');
  if (ba) ba.classList.remove('db-ba--animated');
  const cjourney = card.querySelector('.db-cjourney');
  if (cjourney) cjourney.classList.remove('db-cjourney--animated');
  if (card.querySelector('.db-api-flow')) resetApiFlow(card);
}

// Hook into Flickity — animate each card once when it becomes selected
if (flkty) {
  // Flickity's `contain` left-aligns the first/last cards. On phones, where one
  // card fills the view, that reads as "off-center", so disable contain there
  // and let cellAlign:center center every card.
  function setCarouselContain() {
    const wantContain = window.innerWidth > 820;
    if (flkty.options.contain !== wantContain) {
      flkty.options.contain = wantContain;
      flkty.resize();
      flkty.select(flkty.selectedIndex, false, true);
    }
  }
  setCarouselContain();
  let carouselContainRT;
  window.addEventListener('resize', () => {
    clearTimeout(carouselContainRT);
    carouselContainRT = setTimeout(setCarouselContain, 200);
  });

  const animatedCards = new Set();

  function animateOnce(index) {
    const card = flkty.cells[index] && flkty.cells[index].element;
    if (!card || animatedCards.has(index)) return;
    animatedCards.add(index);
    // Small delay so card settles visually first
    setTimeout(() => animateCard(card), 300);
  }

  // Animate first card when carousel scrolls into view
  const carouselEl = document.getElementById('db-carousel__track');
  if (carouselEl) {
    const cObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateOnce(0);
          cObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    cObs.observe(carouselEl);
  }

  // Animate on select
  flkty.on('select', function() {
    animateOnce(flkty.selectedIndex);
  });

  // Click on non-selected card navigates immediately
  flkty.cells.forEach((cell, i) => {
    cell.element.addEventListener('click', function() {
      if (flkty.selectedIndex !== i) {
        flkty.select(i);
      }
    });
  });
}


// Pressona inline input - wrap for gradient border
// <input> elements can't have ::before pseudo-elements, so we inject
// a thin wrapper div and hang the animated border on that instead.
document.querySelectorAll('.pai-inline-input').forEach(input => {
  const wrap = document.createElement('div');
  wrap.className = 'pai-input-border-wrap';
  input.parentNode.insertBefore(wrap, input);
  wrap.appendChild(input);
});

// Resume modal
});

// Gravity Forms success icon — injects an animated SVG checkmark into
// any .gform_confirmation_message that appears (initial render or AJAX).
(function () {
  const SVG = '<svg viewBox="0 0 80 80" aria-hidden="true">' +
    '<defs><linearGradient id="db-success-grad" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0%" stop-color="#f59e42"/>' +
    '<stop offset="100%" stop-color="#f97853"/>' +
    '</linearGradient></defs>' +
    '<circle cx="40" cy="40" r="38" fill="url(#db-success-grad)"/>' +
    '<path d="M22 41 L35 54 L58 30" fill="none" stroke="#fff" stroke-width="6" ' +
    'stroke-linecap="round" stroke-linejoin="round" class="db-success-icon__check"/>' +
    '</svg>';

  function inject(el) {
    if (!el || el.querySelector('.db-success-icon')) return;
    dbTrack('generate_lead', { form: 'contact' });
    const icon = document.createElement('div');
    icon.className = 'db-success-icon';
    icon.innerHTML = SVG;
    el.prepend(icon);
  }

  function scan() {
    document.querySelectorAll('.gform_confirmation_message').forEach(inject);
  }

  // Initial scan (handles non-AJAX submits where confirmation is in the page on load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Watch for AJAX-injected confirmations
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('gform_confirmation_message')) {
          inject(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.gform_confirmation_message').forEach(inject);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Insights From The Data — rotating analyst notes with category filters,
// auto-rotation, pause/controls, randomized start, and reduced-motion support.
(function () {
  function initInsights() {
    const section = document.getElementById('insights');
    if (!section) return;
    const stage = section.querySelector('.db-insights__stage');
    const notes = Array.prototype.slice.call(section.querySelectorAll('.db-insights__note'));
    const pills = Array.prototype.slice.call(section.querySelectorAll('.db-insights__pill'));
    const bar = section.querySelector('.db-insights__progress-bar');
    const playBtn = section.querySelector('[data-act="toggle"]');
    const nextBtn = section.querySelector('[data-act="next"]');
    const prevBtn = section.querySelector('[data-act="prev"]');
    if (notes.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ROTATE_MS = 7000;
    let filter = 'all';
    let pos = 0;
    let timer = null;
    let playing = !reduce;

    // Randomize starting order so the section feels fresh on each load.
    const order = notes.map(function (_, i) { return i; });
    for (let i = order.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const t = order[i]; order[i] = order[j]; order[j] = t;
    }

    function pool() {
      return order.filter(function (i) {
        return filter === 'all' || notes[i].dataset.type === filter;
      });
    }
    function render() {
      const p = pool();
      if (!p.length) return;
      pos = ((pos % p.length) + p.length) % p.length;
      const activeIdx = p[pos];
      notes.forEach(function (n, i) { n.classList.toggle('is-active', i === activeIdx); });
    }
    function arm() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (bar) { bar.style.transition = 'none'; bar.style.width = '0%'; }
      if (playing && !reduce && pool().length > 1) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (bar) { bar.style.transition = 'width ' + ROTATE_MS + 'ms linear'; bar.style.width = '100%'; }
          });
        });
        timer = setTimeout(function () { pos++; render(); arm(); }, ROTATE_MS);
      }
    }
    function go(delta) { pos += delta; render(); arm(); }
    function setFilter(f) {
      filter = f; pos = 0;
      pills.forEach(function (p) {
        const on = p.dataset.filter === f;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      render(); arm();
    }
    function toggle() {
      playing = !playing;
      playBtn.classList.toggle('is-paused', !playing);
      playBtn.setAttribute('aria-label', playing ? 'Pause rotation' : 'Play rotation');
      arm();
    }

    pills.forEach(function (p) { p.addEventListener('click', function () { setFilter(p.dataset.filter); }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (playBtn) playBtn.addEventListener('click', toggle);
    stage.addEventListener('mouseenter', function () { if (timer) { clearTimeout(timer); timer = null; } if (bar) bar.style.transition = 'none'; });
    stage.addEventListener('mouseleave', function () { if (playing) arm(); });
    section.addEventListener('focusin', function () { if (timer) { clearTimeout(timer); timer = null; } });
    section.addEventListener('focusout', function () { if (playing) arm(); });

    section.classList.add('is-live');
    render();
    arm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInsights);
  } else {
    initInsights();
  }
})();
